module.exports = {
	"_format": "hh-sol-artifact-1",
	"contractName": "Babylonian",
	"sourceName": "contracts/levels/Babylonian.sol",
	"abi": [],
	"bytecode": "0x60566023600b82828239805160001a607314601657fe5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220f9b1d19f2033d741b5b73dc523c5dcb5e81da1fcd16e7651c46e05b5a0eb861f64736f6c634300060c0033",
	"deployedBytecode": "0x73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220f9b1d19f2033d741b5b73dc523c5dcb5e81da1fcd16e7651c46e05b5a0eb861f64736f6c634300060c0033",
	"linkReferences": {},
	"deployedLinkReferences": {}
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/Babylonian.sol/Babylonian.json
// module id = 1527
// module chunks = 0